import React, { useState } from "react";
import { Close } from "@mui/icons-material";
import { Modal, Radio } from "antd";
import { useSelector } from "react-redux";
import AddListModal from "../../pages/leads/pages/leads-list/add-list";
import { BeatLoader } from "react-spinners";
import { toast } from "react-toastify";
import http from "../../services/http";
import "./styles.scss";

function AddLeadModal({ preview, data, title, closeHandler }) {
  // STATES
  const [addPreview, setaddPreview] = useState(false);
  const [selectedList, setSelectedList] = useState("default");
  const [isLoading, setLoading] = useState(false);

  // REDUX DATA
  const selectedCompany = useSelector((state) => state.CompanyReducer.selected_company);
  const list = useSelector((state) => state.LeadsListReducer.leadsList);

  // HANDLERS
  const addPreviewHandler = () => {
    setaddPreview(!addPreview);
  };

  const addLeadHandler = async () => {
    setLoading(true);
    let params = {
      user_company_id: selectedCompany.id,
      company_name: selectedCompany.company_name,
      list: selectedList === "default" ? null : selectedList,
      lead_name: data.company_name,
      url: data.url,
      email: "",
      contact_number: "",
      is_recommended: 1,
      user_notes: "",
      status: "New lead",
      state: data.us_state_full,
      country: data.country,
      location: data.hq_address,
      recommended_lead_notes: {
        financial_synergies: data.financial_synergies,
        reasoning: data?.reasoning ?? "",
        misc_synergies: data.misc_synergies,
        operating_synergies: data.operating_synergies,
      },
    };
    http
      .post(`user-lead`, params)
      .then(({ data }) => {
        toast.success("Added to leads successfully");
        closeHandler();
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error ?? "Something went wrong");
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Modal
        centered
        width={550}
        open={preview && !addPreview}
        onCancel={closeHandler}
        footer={null}
        closable={false}
        className="add-lead-modal"
      >
        <div className="top-box">
          <h2>Choose a list to save {title} to:</h2>
          <button className="close-btn" onClick={closeHandler}>
            <Close />
          </button>
        </div>
        <ul>
          <li onClick={() => setSelectedList("default")}>
            <Radio value="default" checked={selectedList === "default"}>
              General
            </Radio>
          </li>
          {list.map((item) => (
            <li key={item.id} onClick={() => setSelectedList(item.id)}>
              <Radio value={item.id} checked={selectedList === item.id}>
                {item.name}
              </Radio>
            </li>
          ))}
        </ul>
        <div className="bottom-wrapper">
          <button className="new-button" onClick={addPreviewHandler}>
            Create new list
          </button>
          <button className="save-btn" onClick={addLeadHandler}>
            {isLoading ? <BeatLoader size={7} color="#fff" /> : "Save to list"}
          </button>
        </div>
      </Modal>
      <AddListModal preview={addPreview} previewHandler={addPreviewHandler} />
    </>
  );
}

export default AddLeadModal;
